<template>
  <div
    v-if="residence && residence.availability_months.length > 0"
    class="housingTable"
  >
    <el-tabs
      v-model="activeName"
      class="housingTable__tabs"
    >
      <el-tab-pane
        v-for="(yearMonth, index) of months"
        :key="index"
        v-loading="loading"
        class="housingTable__tabs-pane"
        :label="$moment(yearMonth).format('MMM YYYY')"
        :name="yearMonth"
        :class="{ full: offers && offers.length === 0 }"
      >
        <template v-if="offers && offers.length === 0">
          <el-alert
            title="Information"
            type="info"
            :description="$t('residences.accomodation.alertDescription')"
            show-icon
          />
        </template>
        <accomodation-card
          v-for="offer of offers"
          :key="`${index + '-' + offer.id}`"
          :selected-month="activeName"
          :offer="offer"
          :residence="residence"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
  <div v-else>
    <el-alert
      :show-icon="true"
      :title="$t('residences.accomodation.information')"
      :description="$t('residences.accomodation.nothingAvailable')"
      type="info"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AccomodationCard from './AccomodationCard'
export default {
  name: "AccomodationTable",
  components: {
    AccomodationCard
  },
  props: {
    residence: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    activeName: null,
    loading: false
  }),
  computed: {
    ...mapState({
      offers: state => state.residences.selectedResidenceOffers
    }),
    months() {
      // Fix for Safari
      return this.residence.availability_months
        .map(month => {
          const monthYear = month.split('-')

          if (monthYear[1].length < 2) {
            monthYear[1] = "0" + monthYear[1]
          }

          return monthYear[0] + '-' + monthYear[1]
        })
    }
  },
  watch: {
    residence: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.availability_months) {
          this.activeName = this.months[0]
          this.refreshData(this.activeName)
        }
      }
    },
    activeName: {
      immediate: true,
      handler(newVal) {
        this.refreshData(newVal)
      }
    }
  },
  methods: {
    async refreshData(yearMonth) {
      if (this.residence) {
        this.loading = true
        await this.$store.dispatch('residences/getSelectedResidenceOffers', {
          id: this.residence.id,
          year_month: yearMonth
        })
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$c: '.housingTable';

#{$c} {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  &__tabs {
    width: 100%;

    &-pane {
      display: grid;
      @include respond-between(md, lg) {
        grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
      }
      gap: 6px;
      margin-bottom: 5px;

      &.full {
        display: block;
      }
    }
  }
}
</style>